import styled from "styled-components";

import customMedia from "../../../../config/breakpoints";

export const TitleContainer = styled.div`
  width: 70%;
  span {
    color: ${({ theme }) => theme.colors.blue};
  }

  ${customMedia.lessThan("tablet")`
    width: 100%;
  `}
`;
export const SubTitleContainer = styled.div`
  margin-top: 24px;
  width: 100%;

  ${customMedia.greaterThan("desktop")`
    width: 70%;
  `}
`;

export const AdviceCardContainer = styled.div`
  margin: 40px 0 30px 0;
  width: 100%;
`;

export const ButtonContainer = styled.div`
  ${customMedia.lessThan("mobile")`
    width: 100%;
  `}

  span {
    font-style: italic;
    opacity: 0.7;
    font-weight: 600;
    font-size: 16px;
  }
`;

export const StepsBlocContainer = styled.div`
  width: 100%;
  margin: 50px 0 40px 0;
`;
